import { progressActionTypes } from '@constants/actionTypes/commonActionTypes';

export const INITIAL_STATE = {
    processing : false,
    processingPercentage : 0
};

export default function(state = INITIAL_STATE, action = {}) {
    switch(action.type) {
        case progressActionTypes.FILE_PROCESSING:
            return {
                ...state,
                processing: true,
                processingPercentage: action.payload
            };  
        case progressActionTypes.FILE_PROCESSED:
            return {
                ...state,
                processing: false,
                processingPercentage: action.payload
            };
        default:
            return state;
    }
}